
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, MenuItem, Select, FormControl, InputLabel, Paper } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { ActualizarCiudad, AgregarCiudad, Ciudades } from '../../connections/catalogos/CiudadConnection';
import { ObtenerEstados } from '../../connections/catalogos/EstadoConnection';
import { ObtenerMunicipio } from '../../connections/catalogos/MunicipioConnection';

import { CiudadProps } from '../../interfaces/catalogos/CiudadInterface';
import { EstadoProps } from '../../interfaces/catalogos/EstadoInterface';
import { MunicipioProps } from '../../interfaces/catalogos/MunicipioInterface';

export const CiudadPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [CiudadArray, setCiudadArray] = useState<CiudadProps[]>( [] );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idCiudad, setIdCiudad] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const [estado, setEstado] = useState( 0 );
    const [estadoArray, setEstadoArray] = useState<EstadoProps[]>( [] );

    const [municipio, setMunicipio] = useState( 0 );
    const [municipioArray, setMunicipioArray] = useState<MunicipioProps[]>( [] );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const [filtroEstado, setFiltroEstado] = useState( '' );
    const [filtroMunicipio, setFiltroMunicipio] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( CiudadArray, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const fe = filtroEstado.toLowerCase();
        const fm = filtroMunicipio.toLowerCase();
        return (
            ( filtro === '' || ( item.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroEstado === '' || ( item.estado?.descripcion?.toLowerCase().includes( fe ) ?? false ) ) &&
            ( filtroMunicipio === '' || ( item.municipio?.descripcion?.toLowerCase().includes( fm ) ?? false ) )
        );
    });

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const CiudadSelected = CiudadArray.find( (elem) => elem.idCiudad === id );

        if ( CiudadSelected ) {

            await ActualizarCiudad({ ...CiudadSelected, activo: checked }).then( resp => {

                if ( resp.idCiudad ) {

                    var newArray = CiudadArray.map( (elem) => {

                        if ( elem.idCiudad === id ) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setCiudadArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                }

            });
        }

    }

    const handleGuardar = async () => {

        if ( idCiudad !== 0 ) {

            const CiudadSelected = CiudadArray.find( (elem) => elem.idCiudad === idCiudad );

            if ( CiudadSelected ) {

                setLoading( true );

                await ActualizarCiudad({ ...CiudadSelected, descripcion, idEstado: estado, idMunicipio: municipio, }).then( resp => {

                    if ( resp.idCiudad ) {

                        setTimeout(() => {

                            var newArray = CiudadArray.map( (elem) => {

                                if ( elem.idCiudad === idCiudad ) {
                                    elem.descripcion = descripcion;
                                    elem.idEstado = resp.idEstado;
                                    elem.estado = resp.estado;
                                    elem.idMunicipio = resp.idMunicipio;
                                    elem.municipio = resp.municipio;
                                }

                                return elem;
                            });

                            setCiudadArray( newArray );
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const ciudad: CiudadProps = {
                idCiudad: 0,
                clave: '',
                descripcion: descripcion,
                idEstado: estado,
                idMunicipio: municipio,
                activo: true,
            };

            setLoading( true );

            await AgregarCiudad( ciudad ).then( resp => {

                if ( resp.idCiudad ) {

                    setTimeout(() => {

                        setCiudadArray( [...CiudadArray, resp] );
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó la ciudad correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    const EditarRegistro = ({ idCiudad, descripcion, idEstado, idMunicipio }: CiudadProps ) => {

        setDescripcion( descripcion );
        setEstado( idEstado );

        setIdCiudad( idCiudad );

        asyncMunicipiosEdit( idEstado, idMunicipio );

        setOpenDialog( true );
    }

    const asyncMunicipiosEdit = async ( idEstado: number, idMunicipio: number ) => {

        await ObtenerMunicipio( idEstado ).then( resp => {

            setMunicipioArray( resp );
            setMunicipio( idMunicipio );

        });

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setCiudadArray( [] );

            await Ciudades().then( resp => {

                setTimeout(() => {

                    setCiudadArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerEstados().then( resp => {
                setEstadoArray( resp );
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener() {

            setMunicipio( 0 );

            if ( estado !== 0 ) {
                await ObtenerMunicipio( estado ).then( resp => {
                    setMunicipioArray( resp );
                });
            }

        }

        Obtener();

    }, [ estado ]);

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Ciudad' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdCiudad( 0 );
                            setMunicipio( 0 );
                            setEstado( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={ 2 }>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroEstado }
                        label='Buscar por estado'
                        onChange={ ( value ) => {
                            setFiltroEstado( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroMunicipio }
                        label='Buscar por municipio'
                        onChange={ ( value ) => {
                            setFiltroMunicipio( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center'  }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> Clave </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Municipio </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Estado </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                    :
                                    dataFiltrada
                            )
                                .map( ({ idCiudad, clave, descripcion, activo, idEstado, estado, idMunicipio, municipio }) => (

                                    <TableRow key={ idCiudad } >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center'  }}>
                                            { idCiudad }
                                        </TableCell>

                                        <TableCell>
                                            { clave }
                                        </TableCell>

                                        <TableCell>
                                            { descripcion }
                                        </TableCell>

                                        <TableCell>
                                            { municipio?.descripcion }
                                        </TableCell>

                                        <TableCell>
                                            { estado?.descripcion }
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={ activo }
                                                onChange={ (e) => handleChangeChecked( e.target.checked, idCiudad ) }
                                            />

                                            <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => EditarRegistro( { idCiudad, clave, descripcion, idEstado, estado, idMunicipio, municipio, activo } ) }
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                                ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                                :
                                loadingData
                                &&
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <CircularProgress size={ 32 } />

                                    </TableCell>

                                </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: { dataFiltrada.length }
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } sx={{ mt: 3 }}>

                        <Grid size={{ md: 6, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel>Estado</InputLabel>

                                <Select
                                    label='Estado'
                                    value={ estado }
                                    onChange={ (e) => { setEstado( e.target.value ); }}
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        estadoArray.map( (elem) => (
                                            <MenuItem key={ elem.idEstado } value={ elem.idEstado }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 6, xs: 12 }}>

                            <FormControl fullWidth>

                                <InputLabel id='select-municipio-label'>Municipio</InputLabel>

                                <Select
                                    fullWidth
                                    label='Municipio'
                                    value={ municipio }
                                    disabled={ estado === 0 }
                                    onChange={ (e) => { setMunicipio( e.target.value ); }}
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        municipioArray.map( (elem) => (
                                            <MenuItem key={ elem.idMunicipio } value={ elem.idMunicipio }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <TextField
                                label={ 'Descripción' }
                                variant='outlined'
                                multiline
                                rows={ 4 }
                                fullWidth
                                value={ descripcion }
                                onChange={ (e) => setDescripcion( e.target.value ) }
                                slotProps={{
                                    input: {
                                        autoComplete: 'off'
                                    },
                                    inputLabel: {
                                        shrink: true,
                                    }
                                }}
                            />

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); } }> Cancelar </Button>
                    <Button
                        variant='contained'
                        loading={ loading }
                        disabled={ descripcion === '' || estado === 0 || municipio === 0 }
                        onClick={ handleGuardar }
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}
